/**
 * playChime — plays a short, gentle 2-note chime using the Web Audio API.
 * No asset files required, works offline, and can't crash if the browser
 * blocks audio (returns quietly). Intended for tiny UI cues like a Hint
 * popping open — NOT for extended audio (use ElevenLabs TTS for that).
 */
let sharedCtx = null;

const getContext = () => {
  try {
    if (sharedCtx) return sharedCtx;
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    sharedCtx = new Ctor();
    return sharedCtx;
  } catch (err) {
    return null;
  }
};

export const playChime = ({ frequencies = [880, 1320], duration = 0.18, volume = 0.12 } = {}) => {
  const ctx = getContext();
  if (!ctx) return;
  try {
    // Some browsers suspend the context until a user gesture — resume best-effort
    if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
    frequencies.forEach((freq, i) => {
      const start = ctx.currentTime + i * (duration * 0.5);
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(volume, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + duration + 0.02);
    });
  } catch (err) {
    // Silently ignore — the chime is a nice-to-have, never a hard requirement
  }
};

export default playChime;
